import React from 'react';
import WordPressDetails from './WordPressDetails';
import './Price.css';
import upwork from '../../image/upwork.png';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircle } from '@fortawesome/free-solid-svg-icons';
import ReactProject from './ReactProject';

const wordPressData = [
    {
        id:3,
        price:35,
        a:"WordPress Install",
        b:"Create 2 pages",
        c:"Backup Website",
        d:"Free Website Transfer",
        e:"Security Included",
        m:"Revision Unlimited",
        url:"https://www.upwork.com/fl/nazmulahsan",
        title:"NORMAL",
        name:"PSD To React",
        n:"HTML & CSS",
        o:"Bootstrap",
        p:"React",
        v:50,
        w:"Hosting by Firebase Free",

    },
    {
        id:2,
        price:250,
        a:"WordPress Install",
        b:"Fully Responsive",
        c:"10 pages Website Design",
        d:"E-Commerce Functionality",
        e:"Setup payment method",
        f:"50 Products Upload",
        g:"Backup Website",
        h:"Free Website Transfer",
        i:"Security Included",
        url:"https://www.upwork.com/fl/nazmulahsan",
        title:"STANDARD",
        name:"Portfolio Site",
        n:"HTML & CSS",
        o:"Bootstrap",
        p:"React",
        q:"React Router",
        r:"Slider",
        s:"Data From Mongodb",
        v:100,
        w:"Hosting by Firebase Free",
        m:"Revision Unlimited",
    },
    {
        id:3,
        price:550,
        a:"WordPress Install",
        b:"Eyecatching Design",
        c:"Fully Responsive",
        d:"20 pages Website Design",
        e:"E-Commerce Functionality",
        f:"50 Products Upload",
        g:"Hosting Support",
        h:"Setup paymet method",
        i:"Unlimited Plugin Install",
        j:"Backup Website",
        k:"Free Website Transfer",
        l:"Fully Responsive",
        m:"Revision Unlimited",
        url:"https://www.upwork.com/fl/nazmulahsan",
        title:"GROW-BIG",
        name:"Complete Website",
        n:"HTML & CSS",
        o:"Bootstrap",
        p:"React",
        q:"React Router",
        r:"Slider",
        s:"Data From Mongodb",
        t:"Frontend & Backend",
        U: "10 pages Website Design",
        v:500,
        w:"Hosting by Firebase Free",
    },
]

const WordPress = () => {
    
    return (
       <div className="priceSection">
            <div className="container pt-5">
            
        <h2 className="text-center text-white mt-5 mb-2"><span>PRICING TABLE </span> MODULE</h2>
        <div className="separator text-center mb-5">
                    <span><FontAwesomeIcon icon={faCircle}/></span>
                </div>
                <div className="text-center text-white"><h4>Wordpress Site</h4></div>
                <div className="d-flex">
                            {
                                wordPressData.map(data=> <WordPressDetails key={data.id} data={data}/>)
                            }
                    </div>
                    <hr />
                <div className="text-center text-white"><h4>React Project</h4></div>
               <div className="d-flex">
                    {
                        wordPressData.map(react=> <ReactProject key={react.id} react={react}/>)
                    }
              </div>
           <div id="contact" className="upwork text-center text-white pt-5">
           <hr />
           <h2 className="mt-5"><span>HIRE</span> US</h2>
               <div className="separator text-center mb-5">
                    <span><FontAwesomeIcon icon={faCircle}/></span>
                </div>
                <hr />
               <a href="https://www.upwork.com/fl/nazmulahsan"><img src={upwork} alt="" /></a>
           </div>
        </div>
       </div>
    );
};

export default WordPress;